var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wapper-menu-mobile"}},[_c('div',{attrs:{"id":"menu-mobile"}},[_c('Menu')],1),_c('div',{staticClass:"layout-mask-menu-mobile",attrs:{"id":"layout-mask-menu-mobile"},on:{"click":function($event){return _vm.activeMenu()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }